import { render } from "./ActivityTable.vue?vue&type=template&id=44473353&ts=true"
import script from "./ActivityTable.vue?vue&type=script&lang=ts"
export * from "./ActivityTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__